/* eslint-disable @next/next/no-img-element */
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { DEALS_CONFIG } from '../../../../brands/default/config';
import {
  replaceImageServer,
  usePlaceholderImage,
} from '../../../../helpers/image';
import ThemeContext from '../../../../providers/ThemeProvider';

const ImageComponent = ({ deal = {}, image = {} }) => {
  const theme = useContext(ThemeContext);

  return (
    <picture className="single-image__picture">
      <source
        media={`(max-width: ${theme.breakpoints.smDown})`}
        srcSet={replaceImageServer({
          dealId: deal.id,
          height: DEALS_CONFIG.DEFAULT_DEAL_IMG_WIDTH_MOBILE,
          image,
          width: DEALS_CONFIG.DEFAULT_DEAL_IMG_HEIGHT_MOBILE,
        })}
      />
      <img
        alt={image.alt}
        className="single-image__image"
        onError={usePlaceholderImage}
        src={replaceImageServer({ dealId: deal.id, image })}
      />
    </picture>
  );
};

ImageComponent.propTypes = {
  deal: PropTypes.object,
  image: PropTypes.object,
};

export default ImageComponent;
